import { render, staticRenderFns } from "./weal.vue?vue&type=template&id=ee8c7f82&scoped=true"
import script from "./weal.vue?vue&type=script&lang=js"
export * from "./weal.vue?vue&type=script&lang=js"
import style0 from "./weal.vue?vue&type=style&index=0&id=ee8c7f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8c7f82",
  null
  
)

export default component.exports